<template>
  <div class="head-tructure">
    <div class="head-content">
      <el-row>
        <el-col :span="2">
          <div
            @click="gohome"
            :class="['logo-body', { 'logo-body-mini': !isHome }]"
          >
            <img :src="LogoSrc" alt="" />
          </div>
        </el-col>
        <el-col :span="22">
          <div class="login-body-content textAlignRight">
            <Menu></Menu>
            <div class="login-regist">
              <span v-if="islogin">
                <span class="padding18_0" @click="toMessageCenter">
                  <el-badge
                    :value="messageNums"
                    :max="99"
                    class="fontSize18 badge"
                  >
                    <i class="el-icon-message-solid"></i>
                  </el-badge>
                </span>
                <el-dropdown @command="handleCommand">
                  <span
                    class="el-dropdown-link"
                    style="line-height: 75px; padding-left: 10px"
                  >
                    <el-button
                      style="color: #fff"
                      type="text"
                      @click="toPersonalCenter"
                      >{{
                        this.$store.state.userLoginedInfo.userName
                      }}</el-button
                    >
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <!-- <el-dropdown-item command="a">修改密码</el-dropdown-item>
                  <el-dropdown-item command="b">问题反馈</el-dropdown-item> -->
                    <el-dropdown-item command="c">退出</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </span>
              <span v-else>
                <ul class="registLogin-wrap">
                  <li @click="login">登录</li>
                  <li style="margin: 0 14px">|</li>
                  <li @click="regist">注册</li>
                </ul>
              </span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div v-if="isHome" class="serach-center-wrap">
      <div>
        <p class="nameCN">全国区块链和分布式记账技术标准化技术委员会</p>
        <p class="nameEN">
          China National Blockchain And Distributed Ledger Standardization
          Technical Committee
        </p>
      </div>
      <div class="input-wrap">
        <input
          type="text"
          placeholder="请输入标准名称或标准号"
          v-model="input"
          class="search-input"
        />
        <div class="input-btn" @click="standardQuery">
          <i
            class="el-icon-search"
            style="color: #fff !important; fotn-size: 26px"
          ></i>
        </div>
      </div>
    </div>

    <div v-if="isHome" class="main-data">
      <div class="data-item">
        <p class="data-number"><span class="data-numberitem">{{totalData.standardsUnderStudy}}</span></p>
        <p class="data-title"><span class="data-numberitem">在研标准</span></p>
      </div>
      <div class="data-item">
        <p class="data-number"><span class="data-numberitem">{{totalData.publishedStandard}}</span></p>
        <p class="data-title">
          <span class="data-numberitem">已发布标准</span>
        </p>
      </div>
      <div class="data-item">
        <p class="data-number"><span class="data-numberitem">{{totalData.memberUnit}}</span></p>
        <p class="data-title"><span class="data-numberitem">成员单位</span></p>
      </div>
    </div>
  </div>
</template>

<script>
import { getPersonalSelectMessageCenterStatistics,getPersonalSelectAccountInformation } from "@/api/modules/login";
import {
  gettotalData
} from "@/api/modules/home";
import Menu from "../layout/menu";
export default {
  name: "Home",
  data() {
    return {
       totalData:{
         memberUnit: 0,
publishedStandard: 0,
standardsUnderStudy: 0
      },
      timer: null,
      messageNums: 0,
      showwcmark: false,
      input: "",
      LogoSrc: "./static/img/home/logo.png",
      activeIndex: "1",
    };
  },
  components: {
    Menu,
  },
  computed: {
    islogin() {
      if (
        this.$store.state.userLoginedInfo &&
        this.$store.state.userLoginedInfo.token
      ) {
        return true;
      } else {
        return false;
      }
    },
    isHome() {
      if (this.$route.name === "home") {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.methsgettotalData();
    if (this.islogin) {
      this.searchMessageList();
      this.timer = setTimeout(() => {
        this.searchMessageList();
      }, 30000);
    }
  },
  beforeDestroy() {
    // 页面关闭（路由跳转）时清除定时器
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
      //统计数据
    methsgettotalData(){
      gettotalData().then(res =>{
          this.totalData = res.data;
      })
    },
    standardQuery() {
      console.log("submit!");
      this.$router.push({
        name: "standardQuery",
        query: {
          searchkey: this.input,
        },
      });
    },
    onSearch() {
      let { query = {}, path } = this.$route;
      let { searchkey } = query;
      if (searchkey === this.input || !this.input) {
        return;
      }
      this.$router.push({
        path: "/searchPage",
        query: {
          searchkey: this.input,
        },
      });
    },
    handleCommand(command) {
      if (command === "c") {
        // 退出
        this.$confirm("确定退出登录吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            sessionStorage.clear();
            this.$store.commit("SET_USERLOGINEDINFO", {});
            this.$router.push({
              path: "/",
            });
            this.$message({
              type: "success",
              message: "已退出登录!",
            });
          })
          .catch(() => {
            // this.$message({
            //   type: 'info',
            //   message: '已取消！'
            // });
          });
      }
    },
    gohome() {
      this.$router.push({
        name: "home",
      });
    },
    // 未读消息统计
    searchMessageList() {
      getPersonalSelectMessageCenterStatistics().then((res) => {
        if (res.code === "0000") {
          this.messageNums = res.data;
        }
      });
    },
    toMessageCenter() {
      this.$router.push({
        name: "messageCenter",
      });
    },
    toPersonalCenter() {
      getPersonalSelectAccountInformation().then((res) => {
        // let step = this.$store.state.registStep
        let step = res.data.tcUserEntity.userState;
        if (step == 3 || step == 1) {
          this.$router.push({
            name: "personalCenter_standarDevelopment",
          });
        } else {
          this.$router.push({
            name: "registInfo",
          });
        }
      });
    },
    login() {
      this.$router.push({ name: "login" });
    },
    regist() {
      this.$router.push({ name: "regist" });
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>
<style lang="scss">
@font-face {
  font-family: "LeagueGothic";
  src: url("../../assets/fonts/League_Gothic.ttf");
  // src: url('fonts/league_gothic/league_gothic-webfont.eot?#iefix') format('embedded-opentype'),url('fonts/league_gothic/league_gothic-webfont.woff') format('woff'),url('fonts/league_gothic/league_gothic-webfont.ttf') format('truetype'),url('fonts/league_gothic/league_gothic-webfont.svg#LeagueGothicRegular') format('svg');
  font-weight: normal;
  font-style: normal;
}
</style>
<style lang="scss" scoped>
.head-tructure {
  width: 100%;
  // height: 637px;
  background: url("../../assets/img/headbg.png") no-repeat 100% 100%;
  background-size: cover;
  .main-data {
    margin: 0 auto;
    padding: 0 15%;
    height: 180px;
    background: rgba(0, 70, 180, 0.2);
    background-blend-mode: normal;
    mix-blend-mode: normal;
    display: flex;

    .data-item {
      //  padding: 44px 33px;
      padding-top: 44px;
      width: 33%;
      height: 100%;
      border-left: 1px solid rgba(255, 255, 255, 0.24);
      text-align: center;
      .data-number {
        margin-left: -2px;
        color: rgba(255, 255, 255, 1);
        font-size: 42px;
        border-left: 2px solid #fff;
      }
      .data-numberitem {
        padding-left: 30px;
        font-family: "LeagueGothic", "Arial";
      }
      .data-title {
        color: rgba(255, 255, 255, 1);
        font-size: 16px;
        line-height: 30px;
      }
    }
  }
  .serach-center-wrap {
    width: 910px;
    margin: 0px auto 125px;
    text-align: center;
    .nameCN {
      mix-blend-mode: normal;
      color: rgba(255, 255, 255, 1);
      font-size: 40px;
      text-align: center;
      line-height: 59px;
    }
    .nameEN {
      mix-blend-mode: normal;
      color: rgba(255, 255, 255, 1);
      font-size: 16px;
      line-height: 24px;
      text-align: center;
    }
    .input-wrap {
      margin-top: 50px;
      height: 50px;
      border-radius: 8px;
      // overflow: hidden;
      display: flex;

      .search-input {
        flex: 1;
        height: 50px;
        width: 830px;
        border-radius: 8px 0 0 8px;
        padding-left: 16px;
        border-left: 1px solid #e1e3e6;
        border-top: 1px solid #e1e3e6;
        border-bottom: 1px solid #e1e3e6;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #242933;
        line-height: 22px;
        border: none;
      }
      .search-input::placeholder {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #b2b2b2;
        line-height: 22px;
      }
      .input-btn {
        width: 84px;
        height: 50px;
        background: rgba(240, 157, 55, 1);
        border-radius: 0px 8px 8px 0px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #fefeff;
        line-height: 50px;
        text-align: center;
        cursor: pointer;

        &:active {
          opacity: 0.8;
        }
      }
    }
  }
  .head-content {
    margin: 0 auto;
    width: $base-width;
  }
  .badge {
    cursor: pointer;
    margin-right: 10px;
    color: #fff;
  }
  .logo-body {
    display: flex;
    cursor: pointer;
    width: 130px;
    height: 150px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.8) 0%,
      rgba(255, 255, 255, 0.5) 100%
    );
    background-blend-mode: normal;
    mix-blend-mode: normal;
    align-items: center;
    justify-content: center;
    border-radius: 0 0 8px 8px;

    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.8) 0%,
      rgba(255, 255, 255, 0.5) 100%
    );
    background-blend-mode: normal;
    mix-blend-mode: normal;
    img {
      width: 95px;
      height: 95px;
    }
  }
  .logo-body-mini {
    height: 60px;
    width: 60px;
    margin: 0 6px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.8) 0%,
      rgba(255, 255, 255, 0.5) 100%
    );
    background-blend-mode: normal;
    mix-blend-mode: normal;
    img {
      height: 50px;
      width: 50px;
    }
  }
  .login-body-content {
    padding: 5px 10px;
    .weichat {
      display: inline-block;
      cursor: pointer;
      height: 20px;
      width: 20px;
      background: url("../../assets/img/weichat.png") no-repeat 100% 100%;
      background-size: cover;
      vertical-align: middle;
      margin: 0 14px;
      position: relative;
    }
    .login-regist {
      float: right;
    }
    .search {
      width: 280px;
      background: $color-grey;
      border: none !important;
    }
    .registLogin-wrap {
      cursor: pointer;
      display: inline-block;
      color: #fff;
      font-size: 17px;
      vertical-align: middle;
      li {
        line-height: 75px;
        float: left;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/head.vue